import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaterialSymbolsSortUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 448 448",
	xmlSpace: "preserve",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m355 378 68.9-68.9c2.81-2.81 6.1-4.16 9.85-4.05s7.03 1.58 9.85 4.4c2.58 2.81 3.93 6.1 4.05 9.85s-1.23 7.03-4.05 9.85l-92.9 92.9c-1.41 1.41-2.93 2.41-4.57 3s-3.4.877-5.28.858-3.63-.314-5.28-.886c-1.64-.572-3.17-1.57-4.57-2.98l-92.9-92.9c-2.58-2.58-3.87-5.81-3.87-9.68s1.29-7.21 3.87-10c2.81-2.81 6.16-4.22 10-4.22s7.21 1.41 10 4.22l68.6 68.6v-342c0-3.99 1.35-7.33 4.05-10 2.7-2.7 6.04-4.05 10-4.04 3.98.01 7.32 1.36 10 4.05 2.71 2.69 4.06 6.03 4.04 10z" }),
			/* @__PURE__ */ _jsx("path", { d: "M0 192 72.5 0h41.6l72.5 192h-39.7l-16.4-46.1H56L40.5 192zm67.7-78.7H118l-23.2-72h-2.9z" }),
			/* @__PURE__ */ _jsx("path", { d: "M24 448v-36.5l95.9-121H27.8v-34.6h134v36.5l-95 121h95.9V448z" })
		]
	})
});
export default SvgMaterialSymbolsSortUp;
